module.exports = __webpack_public_path__ + "@/assets/img/instagram.b766865d.svg";